import React, {Fragment,Component,useState,useEffect} from 'react';
import axios from 'axios';
import {connect} from 'react-redux';
import Iframe from "react-iframe"
import { Redirect,Link } from 'react-router-dom';
import { Table,Placeholder } from 'semantic-ui-react';
import {
  Menu,
  Segment,
  Container,
  Divider,
  Message,
  Icon,
  Header,
  Dimmer,
  Responsive,
  Modal,
  Button,
  Image,
  Loader,
  Tab,
  Label
} from 'semantic-ui-react';
import {Base64} from 'js-base64';
import Clipboard from 'react-clipboard.js';

function Guide(props){

  const {t}       = props;
  const mobile    = /Android|iPhone|iPod/.test(navigator.userAgent);
  const title     = props.data.title;
  const port      = props.data.port;
  const password  = props.data.password;
  const code      = props.data.code;
  const hashed    = props.data.hashed;
  const user_id   = props.data.user_id;
  const user_vip  = props.data.user_vip;

  var subscribe_endpoint = "update.glados-config.com";
  var alt_subscribe_endpoint = "www.glados-config.com";

  const sub    = 'sub://' + Base64.encode(`https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`) + "#Github.com/GLaDOS-network";
  const suburl           = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`
  const metaurl          = `https://${subscribe_endpoint}/mihomo/${user_id}/${code}/${port}/glados.yaml`
  const metaaltsub       = `https://${alt_subscribe_endpoint}/mihomo/${user_id}/${code}/${port}/glados.yaml`
  const tv_clash_suburl  = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-tv.yaml`
  const fixed_suburl     = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-fixed.yaml`
  const altsub           = `https://${alt_subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.yaml`

  const singurl          = `https://${subscribe_endpoint}/singbox/${user_id}/${hashed}`
  const singft           = `https://${subscribe_endpoint}/sft/${user_id}/${hashed}`
  const singfa           = `https://${subscribe_endpoint}/sfa/${user_id}/${hashed}`

  const ipv6             = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-ipv6.yaml`
  const padavan_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-padavan.yaml`
  const android_suburl   = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-android.yaml`
  const koolshare_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/koolshare.yaml`
  const openclash_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados-openclash.yaml`
  const clash_restrict_suburl = `https://${subscribe_endpoint}/clash/${user_id}/${code}/${port}/glados.restrict.yaml`

  const shadowrocket    = `https://${subscribe_endpoint}/subscribe/${user_id}/${code}/${port}/servers`;
  const quantumultx  = `https://${subscribe_endpoint}/quantumultx/${user_id}/${hashed}`;
  const loon   = `https://${subscribe_endpoint}/loon/${user_id}/${hashed}/glados.network.conf`;
  const v2ray  = `https://${subscribe_endpoint}/v2ray/${user_id}/${hashed}`;

  const [clipboard,setClipboard] = useState(false);

  useEffect(()=>{
    if(clipboard == true){
      setTimeout(()=>{
        setClipboard(false)
      },3000)
    }
  },[clipboard])

  return (
  <Fragment>

    <Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>Clash Meta/Mihomo Config Files
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body style={{fontSize:"0.9rem"}}>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> General
          </Table.Cell>
          <Table.Cell>{metaurl}</Table.Cell>
          <Table.Cell>
            Clients: Mihomo Party/FLClash <br/>
            Optimized for streaming content<br/>
            Support <Link to="/console/rules">Customized Rules Editor</Link>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline' /> Alternative
          </Table.Cell>
          <Table.Cell>{metaaltsub}</Table.Cell>
          <Table.Cell>
            Backup<br/>When your General URL is broken, please use this one
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>

    <Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>Clash Config Files
          </Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body style={{fontSize:"0.9rem"}}>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> General
          </Table.Cell>
          <Table.Cell>{suburl}</Table.Cell>
          <Table.Cell>
            Standard Clash Clients: ClashX CFA CFW Stash<br/>
            Optimized for streaming content<br/>
            Support <Link to="/console/rules">Customized Rules Editor</Link>
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline' /> TV
          </Table.Cell>
          <Table.Cell>{tv_clash_suburl}</Table.Cell>
          <Table.Cell>
            Apple TV/Android TV
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline' /> Alternative
          </Table.Cell>
          <Table.Cell>{altsub}</Table.Cell>
          <Table.Cell>
            Backup<br/>When your General URL is broken, please use this one
          </Table.Cell>
        </Table.Row>

      </Table.Body>
    </Table>

    <Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='3'>More Config Files</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body style={{fontSize:"0.9rem"}}>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> Shadowrocket
          </Table.Cell>
          <Table.Cell>{shadowrocket}</Table.Cell>
          <Table.Cell>
            Shadowrocket
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> Singbox For iOS/macOS
          </Table.Cell>
          <Table.Cell>{singurl}</Table.Cell>
          <Table.Cell>
            Standard Singbox Clients
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> Singbox For tvOS
          </Table.Cell>
          <Table.Cell>{singft}</Table.Cell>
          <Table.Cell>
            Singbox TV Clients
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> Singbox For Android
          </Table.Cell>
          <Table.Cell>{singfa}</Table.Cell>
          <Table.Cell>
            Singbox Android
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>

    <Table celled striped>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell colSpan='2'>Legacy</Table.HeaderCell>
          <Table.HeaderCell colSpan='1'>Limited Support</Table.HeaderCell>
        </Table.Row>
      </Table.Header>

      <Table.Body style={{fontSize:"0.9rem"}}>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> QuantumultX
          </Table.Cell>
          <Table.Cell>{quantumultx}</Table.Cell>
          <Table.Cell>
            QuantumultX
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> Loon
          </Table.Cell>
          <Table.Cell>{loon}</Table.Cell>
          <Table.Cell>
            Loon
          </Table.Cell>
        </Table.Row>
        <Table.Row>
          <Table.Cell>
            <Icon name='file outline'/> V2Ray GUI
          </Table.Cell>
          <Table.Cell>{v2ray}</Table.Cell>
          <Table.Cell>
            Standard V2Ray Clients
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  </Fragment>
  )
}
export {Guide};
